module.exports = __webpack_public_path__ + "static/img/left-radius.531c167.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/left-radius.png
// module id = 6KL4
// module chunks = 0